import moment from 'moment';
import React, { useCallback } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import { isReadOnly as readOnly } from '../../../../SharedModules/utilities/utilities';

export default ({
  rowIndex,
  data,
  handleDeleteRecord,
  setCorrLinkId,
  setCorrId,
  setShowComments,
  hasAccess,
  isEnablebyRole,
}) => {
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly =
      readOnly(window.location.pathname, loginState)?.readOnly || false;
  }
  const particpationDates = useSelector(
    (state) => state.sharedState.GroupReducer.particpationDates
  );
  return (
    <div className='tdCell icon-btn-group'>
      <OverlayTrigger
        placement='bottom'
        overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
      >
        <Button
          data-testid='deleteBtn'
          className='th-ic trash-blue'
          variant='text'
          disabled={data.permanentDelete || isReadOnly || !isEnablebyRole||data?.newRecord==true}
          onClick={() => {
            handleDeleteRecord(rowIndex, data, particpationDates);
          }}
          aria-label='Delete'
        >
          <SVGComponent iconName='Icon-delete' />
        </Button>
      </OverlayTrigger>
      {hasAccess && (
        <OverlayTrigger
          placement='bottom'
          overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
        >
          <Button
            className='th-ic comment-ic'
            variant='text'
            aria-label='comment'
            disabled={isReadOnly || !isEnablebyRole}
          >
            <Button
              className='th-ic comment-ic'
              variant='text'
              onClick={() => {
                setCorrLinkId(data?.corrLinkId);
                setCorrId(data?.clientGroupId?.groupId);
                setShowComments(true);
              }}
              aria-label='comment'
              tabIndex={'0'}
              onKeyDown={(e) => {
                // Handle Enter and Space key events
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // Prevents the default space scrolling behavior
                  setCorrLinkId(data?.corrLinkId);
                  setCorrId(data?.clientGroupId?.groupId);
                  setShowComments(true);
                }
              }}
              disabled={isReadOnly || !isEnablebyRole}
            >
              {parseInt(data.isExistingComment, [0, 1]) === 1 ? (
                <img alt='comment' src={CommentVisibleIcon} />
              ) : (
                <img alt='' src={CommentIcon} />
              )}
            </Button>
          </Button>
        </OverlayTrigger>
      )}
    </div>
  );
};
